<template>
  <div class="pa-4" style="position: relative">
    <h2 class="subheading green--text">Help for Budget Officers</h2>
    <HelpBudget class="larawan" />
    <img
      src="@/assets/Consulting-rafiki.svg"
      class="bg"
      position="right"
      height="450"
      width="auto"
    />
  </div>
</template>

<script>
import HelpBudget from "@/components/Utils/Help-Budget.vue";
export default {
  components: {
    HelpBudget,
  },
  data: () => ({}),
};
</script>

<style scoped>
.bg {
  border-style: none;
  position: absolute;
  right: 10px;
  top: 160px;
  opacity: 0.5;
  z-index: 1;
}
.larawan {
  opacity: 1;
}
</style>